<template>
  <div>
    <div :class="$style.top_row">
      <div :style="{width: '210px'}">
        <vgp-label-slot
          :label="locales('pricing_widget_user_select_label')"
        >
          <template #body>
            <div :class="$style.users_selection">
              <dropdown-select
                :drop-list="dropdownItems"
                :selected="selectedItem"
                :multiselect="false"
                :show-reset-btn="false"
                :show-selected-first="false"
                :fixed-width="280"
                item-template="text"
                track-by-text="text"
                group-by="discountGroup"
                :group-settings="{
                  divider: false,
                  color: '#808080'
                }"
                :left-icon="{
                  name: 'team',
                  type: 'regular',
                  size: 20,
                }"
                @selected="selected => $emit('changeUserCount', selected[0])"
              />
              <div
                v-if="isShowUsersSelectionNotify"
                :class="$style.users_selection_notify"
                @click="onShowContactForm"
                v-html="locales('payment_user_selection_notification_for_large_teams')"
              />
              <div
                v-if="!isShowUsersSelectionNotify"
                :class="[$style.users_selection_notify, $style.not_hover]"
                v-html="locales('tariffs_widget_top_notification')"
              />
            </div>
          </template>
        </vgp-label-slot>
      </div>

      <div :class="[$style.switch, isAnnual ? $style.annual : $style.month]">
        <div
          :class="[$style.tab, $style.monthly]"
          @click="$emit('toggleAnnual', false)"
        >
          {{ locales('plans_monthly_locale') }}
        </div>
        <div
          :class="[$style.tab, $style.annually]"
          @click="$emit('toggleAnnual', true)"
        >
          <div :class="$style.name">
            {{ locales('plans_annually_locale') }}
          </div>
          <div :class="$style.discount_chip">
            - 20%
          </div>
        </div>
      </div>
    </div>

    <div :class="$style.plan_cards">
      <tariff-card
        v-for="(plan, index) in plans"
        ref="card"
        :key="index"
        :plan-data="plan"
        :is-annual="isAnnual"
        :is-popup="isPopup"
        :team-size="selectedItem"
        :heights="cardSectionsHeights"
        @buyPlanClick="plan => $emit('buyPlanClick', plan)"
        @upgradePlanClick="plan => $emit('upgradePlanClick', plan)"
        @onClickLearnMore="() => $emit('onClickLearnMore')"
        @switchToAnnual="() => $emit('switchToAnnual')"
      />
    </div>
  </div>
</template>

<script>
import VgpLabelSlot from '../../../common/VueComponents/label/vgpLabelSlot.vue';
import DropdownSelect from '../../../common/VueComponents/dropdownSelect/dropdownSelect.vue';
import tariffCard from './tariffCard.vue';
import discountSvg from '../discountSvg.vue';
import app from '../../../../app';
import InlineNotification from '$$vueCmp/nofitication/inline/InlineNotification.vue';
import globalStore from '../../../../store/main';

export default {
  name: 'TariffsWidget',
  components: {
    tariffCard,
    DropdownSelect,
    VgpLabelSlot,
    discountSvg,
    InlineNotification,
  },
  props: {
    plans: { type: Array, required: true, default: () => [] },
    usersCountList: { type: Array, required: true, default: () => [] },
    selected: { type: Object, required: true, default: () => {} },
    isPopup: { type: Boolean, required: false, default: false },
    isAnnual: { type: Boolean, required: true, default: false },
  },
  emits: {
    toggleAnnual: null,
    changeUserCount: null,
    buyPlanClick: Object,
    upgradePlanClick: Object,
    onClickLearnMore: null,
    switchToAnnual: null,
  },
  data() {
    return {
      locales: __,
      cardSectionsHeights: {
        featuresSection: 0,
      },
      isShowUsersSelectionNotify: false,
    };
  },
  computed: {
    leftSidebarWidth() {
      return this.$store.getters.leftSidebarWidth;
    },
    dropdownItems() {
      return this.usersCountList.map(item => {
        if (!this.isAnnual && item.count === 1) {
          return {
            ...item,
            text: `${item.count} ${__('one_user_locale_disabled_for_monthly')}`,
          };
        }
        if (this.isAnnual && item.count >= 20) {
          return {
            ...item,
            discountGroup: __('payment_user_selection_discount_label'),
          };
        }

        return {
          ...item,
        };
      });
    },
    splicePlans() {
      const clone = [...this.plans];

      clone.pop();

      return clone;
    },
    blackFridayPlanData() {
      return this.plans[this.plans.length - 1];
    },
    selectedItem() {
      return this.dropdownItems.find(item => item.id === this.selected.id);
    },
  },
  watch: {
    leftSidebarWidth() {
      this.calcHeights();
    },
    selected: {
      handler(selected) {
        if (selected.count === 40) {
          this.isShowUsersSelectionNotify = true;
        } else {
          this.isShowUsersSelectionNotify = false;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    setTimeout(() => {
      this.calcHeights();
    }, 0);
    window.addEventListener('resize', this.calcHeights);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.calcHeights);
  },
  methods: {
    calcHeights() {
      const paymentCrads = this.$refs.card || [];

      this.cardSectionsHeights.featuresSection = 0;

      paymentCrads.forEach(card => {
        const featuresDescription = card.$refs.featuresDesc;
        const featuresList = card.$refs.featuresList;

        const height = featuresDescription?.clientHeight + featuresList?.clientHeight;

        if (height > this.cardSectionsHeights.featuresSection) {
          this.cardSectionsHeights.featuresSection = height;
        }
      });
    },
    onShowContactForm() {
      this.$store.dispatch('globalPopup/show', {
        type: 'contactUs',
        title: 'upgrade-via-sale-contact-us-form',
        width: 440,
      });
      // app.trigger('messageUsForm:show', 'price-app-contact-us-form');
    },
    buyPlanClick(planData) {
      this.$emit('buyPlanClick', planData);
    },
    upgradePlanClick(planData) {
      this.$emit('upgradePlanClick', planData);
    },
  },
};
</script>

<style module lang="less">
  @import '../../../../less/_mixins.less';
  @import '../../../../less/_fonts.less';
  @import '../../../../less/_variables.less';

  .dnone {
    display: none;
  }

 .top_row {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 20px;

    .users_selection {
      width: 100%;
      display: flex;
      align-items: center;

      .users_selection_notify {
        white-space: nowrap;
        margin-top: -2px;
        position: relative;
        .FontLatoRegular;
        .fs(12px, 18px);
        color: #1565C0;
        padding: 8px 12px;
        border-radius: 4px;
        background: #D0E0F2;
        margin-left: 18px;

        &.not_hover {
            &:hover {
                cursor: auto;
            }
        }

        span {
          text-decoration: underline;
          text-underline-offset: 3px;
        }

        &:hover {
          cursor: pointer;
        }

        &::before {
          content: '';
          position: absolute;
          left: -4px;
          top: 50%;
          width: 8px;
          height: 8px;
          background: #D0E0F2;
          transform: translateY(-50%) rotate(45deg);
        }
      }
    }

    .notification {
      margin-left: 16px;

      & > div {
        background: #D0E0F2 !important;
      }
    }

    .switch {
      display: flex;
      align-items: center;
      min-height: 38px;
      background:#E7EFF8;
      border-radius: 48px;
      box-sizing: border-box;
      gap:4px;
      padding: 4px;
      margin-left: auto;

      .tab {
        display: flex;
        align-items: center;
        min-width: 62px;
        padding: 6px 8px;
        box-sizing: border-box;
        .FontLatoBold;
        .fs(12px, 30px);
        color: #1F1F1F;
        padding: 0 12px;

        &.annually {
          display: flex;
          justify-content: space-between;
          position: relative;
          padding: 0 6px 0 12px;

          .save_item {
            position: absolute;
            top: -25px;
            right: 110%;
            min-width: max-content;
            .FontLatoRegular;
            .fs(14px, 20px);
            color: #757575;
          }

          .discount_chip {
            .FontLatoRegular;
            font-size: 10px;
            line-height: 12px;
            color: #fff;
            padding: 4px 8px;
            border-radius: 24px;
            background: #08284D;
            margin-left: 8px;
          }
        }
      }

      &.annual {
        .tab.annually {
          .FontLatoBold;
          background: #1565C0;
          color: #FFFFFF;
          border-radius: 36px;
        }

        .tab.monthly:hover {
          color: #424242;
          text-decoration: underline;
          cursor: pointer;
        }
      }

      &.month {
        .tab.annually {
          .save_item {
            color: @orange;

            &::after {
              border-left: 1px solid @orange;
              border-bottom: 1px solid @orange;
            }
          }

          .discount_chip {
            background: #73A3D9;
          }

          &:hover {
            color: #424242;
            cursor: pointer;

            .name {
              text-decoration: underline;
            }
          }
        }

        .tab.monthly {
          .FontLatoBold;
          background: #1565C0;
          color: #FFFFFF;
          border-radius: 36px;
        }
      }
    }
  }

  .plan_cards {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
</style>
